import {
  View,
  TouchableWithoutFeedback,
  Keyboard,
  Platform,
} from 'react-native';
import { Text, useTheme } from 'react-native-paper';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import GoBackButton from '../components/goBackButton';
import AddBusinessForm from '../components/addBusinessForm';
import { Props } from '../types';

export default function AddBusinessScreen({ navigation }: Props) {
  const theme = useTheme();

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: theme.colors.background,
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      <GoBackButton />

      <Text style={{ paddingLeft: 15, fontSize: 24, fontWeight: '500' }}>
        Add New Business
      </Text>
      <KeyboardAwareScrollView contentContainerStyle={{ flex: 1 }}>
        <TouchableWithoutFeedback
          onPress={Keyboard.dismiss}
          disabled={Platform.OS === 'web'}
        >
          <AddBusinessForm navigation={navigation} />
        </TouchableWithoutFeedback>
      </KeyboardAwareScrollView>
    </View>
  );
}
